<script lang="ts" setup>
import {ref} from 'vue';
import {Vue3Lottie} from 'vue3-lottie';
import goodJobLottie from '@/assets/good-job-lottie.json';


const emit = defineEmits<{
  animationComplete: [];
}>();

const animationRef = ref();
const onAnimationComplete = (): void => {
  emit('animationComplete');
};
</script>

<template>
  <div class="animation-container">
    <vue3-lottie
      ref="animationRef"
      :animation-data="goodJobLottie"
      :loop="false"
      :auto-play="true"
      :scale="0.9"
      @onComplete="onAnimationComplete"
    />
  </div>
</template>

<style lang="scss" scoped>
.animation-container {
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease-in-out;
  width: 100%;
  height: 100%;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
